<template>
    <div class="order-refuse">
        <HeaderNav
            header-title="拒单描述"
            left-icon-name="2"
            right-icon-name=""
        ></HeaderNav>
        <div class="textarea-wrapper">
            <van-field
                v-model="content"
                rows="4"
                autosize
                type="textarea"
                placeholder="请填写拒单描述..."
                maxlength="50"
                show-word-limit
            ></van-field>
        </div>
        <span class="submit-btn" @click="submitRefuse">提交</span>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Toast, Dialog } from 'vant';
export default {
    components: {
        HeaderNav,
    },
    data() {
        return {
            content: '',
        };
    },
    created() {

    },
    methods: {
        submitRefuse() {
            if (this.content === '') {
                this.$toast('请填写拒单描述');
            } else {
                Dialog.confirm({
                    message: '确定要提交？',
                }).then(() => {
                    // on confirm
                    Toast.loading({
                        message: '请求中...',
                        forbidClick: false,
                        loadingType: 'spinner',
                    });
                    this.$axios
                        .put('/interfaceApi/procurement/daily/supply/no_receive', {
                            no: this.$route.params.no,
                            content: this.content,
                        })
                        .then(() => {
                            this.show = false;
                            Toast.success({
                                message: '拒单成功',
                                duration: 500,
                            });
                            setTimeout(() => {
                                this.$router.isBack = 1;
                                this.$router.go(-1);
                            }, 1000);
                        })
                        .catch(error => {
                            this.$toast('message:' + error.Errorcode.Message + '');
                        });
                }).catch(() => {
                    // on cancel
                });
            }
        },
    },
};
</script>

<style lang="stylus">
.order-refuse
    padding-top 44rpx
    height calc(100% - 44rpx)
    position relative
    background #ffffff
    .textarea-wrapper
        width 345rpx
        height 150rpx
        border 2rpx solid rgba(215,215,215,1)
        border-radius 8px
        margin 15rpx auto
        .van-field__control
            height 100% !important;
    .submit-btn
        position absolute
        top 15rpx
        right 15rpx
        color #fff
        font-size 14rpx
        z-index 999
</style>